import { Link } from 'react-router-dom'

import MAP_DATA from '../map_data'

import './css/map-your-move.css'
import './cssom/contact-buttons.css'
import './cssom/info-cards-style-1.css'
import './cssom/mym-details.css'

import { BASE_URL } from '../constants'

const HazardsPage = () => {

  return (
    <>
       <div className="background"></div>
      <nav>
        <div className="wrapper--nav">
        <div className="mym--logo">
            <a href="https://www.horrycounty.org" target="blank"><img src={`images/HC-circle-icon.svg`} alt="HC Government Icon" /></a>
            <Link to="/">
              <span>HC</span>
              <span className="logo-bold">Map Your Move</span>
            </Link>
          </div>
          <ul >
           
              <li className="dropdown">
                
                <a className="hamburger--wrapper"><div className="hamburger"><span>Maps</span></div></a>
                <ul className="map--listings">
                  {MAP_DATA.map(({ title, anchor }, index) => 
                    <li key={index}><a href={`#${anchor}`}>{title}</a></li>)}
                </ul>
              </li>
              <li>
            <Link to="/flood-info">Flood Info</Link>
            </li>

        </ul>
        </div>
      </nav>

    
    <section className="flooding">
      <h2><span>Flood Zone Infomation *</span><span>Recommended Mitigation Strategies </span></h2>
      <div className="info-cards-position">
        <div className="wrapper--info-cards">
          <div className="info-cards card-style-1">
            <div className="wrapper--inner">
                <div className="wrapper--step">
                    <div className="step"><span className="step--count">1</span></div>
                    <span className="step--Title">Purchase Flood Insurance</span>
                </div>
                <div className="icon-identifier">
                  <img src={`images/flood-insurance-icon.svg`} alt="" />
                </div>
                <h4><span>National Flood</span> <span>Insurance Program</span></h4>
                <p>
                Everyone can get flood insurance, even if you do not live in a high risk area. Most homeowners insurance does not cover flood damage. The NFIP can provide flood insurance to property owners, renters and businesses.</p>
            </div>
            <div className="contact">
              <a href="tel:(877)336-2627">
                <img src={`images/phone-icon.svg`} alt="save-icon" /><span>(877)&thinsp;336-2627</span>
              </a>
              
              <a href="http://www.Floodsmart.gov"
                ><img src={`images/website-icon.svg`} alt="save-icon" /><span
                  >National Flood Insurance Program</span
                ></a
              >
            </div>
          </div>
          <div className="info-cards card-style-1">
            <div className="wrapper--inner">
                <div className="wrapper--step">
                    <div className="step"><span className="step--count">2</span></div>
                    <span className="step--Title">Build Safely</span>
                </div>
                <div className="icon-identifier">
                  <img src={`images/code-enforcement-icon.svg`} alt="" />
                </div>
                <h4><span>Horry County</span> <span>Code Enforcement</span></h4>
                <p>
                    Make sure that you understand our building requirements before purchasing a property where you plan to build a home, business or other structure.
                </p>
            </div>
            <div className="contact">
              <a href="tel:(843)915-5090"
                ><img src={`images/phone-icon.svg`} alt="save-icon" /><span
                  >(843)&thinsp;915-5090</span></a>
              
              <a href="https://www.horrycounty.org/departments/codeenforcement"
                ><img src={`images/website-icon.svg`} alt="save-icon" /><span
                  >Horry County Code Enforcement</span></a>
            </div>
          </div>
          <div className="info-cards card-style-1">
            <div className="wrapper--inner">
                <div className="wrapper--step">
                    <div className="step"><span className="step--count">3</span></div>
                    <span className="step--Title">Know Risks</span>
                </div>
                <div className="icon-identifier">
                  <img src={`images/emergency-icon.svg`} alt="" />
                </div>
                <h4><span>Horry County</span> <span>Emergency Management</span></h4>
                <p>
                  You have already taken the first step by reviewing this map and
                  learning more about potential risks for your property.<br/><br/>
                 Have a family disaster plan that includes how you will receive information
                   and emergency alerts and how you will protect important documents.  Have an evacuation plan
                    established for your family.  
                    For more information you can click here<a href="https://www.redcross.org/get-help/how-to-prepare-for-emergencies/make-a-plan.html">Disaster Preparedness Plan | Make a Plan | Red Cross</a>  
                </p>
            </div>
            <div className="contact">
              <a href="tel:(843)915-5150"
                ><img src={`images/phone-icon.svg`} alt="save-icon" /><span
                  >(843)&thinsp;915-5150</span
                ></a
              >
            
              <a href="https://www.horrycounty.org/departments/emergencymanagement"
                ><img src={`images/website-icon.svg`} alt="save-icon" /><span
                  >Horry County Emergency Management</span
                ></a
              >
            </div>
          </div>
          <div className="info-cards card-style-1">
            <div className="wrapper--inner">
                <div className="wrapper--step">
                    <div className="step"><span className="step--count">4</span></div>
                    <span className="step--Title">Protect People & Property</span>
                </div>
                <div className="icon-identifier">
                  <img src={`images/FEMA.png`} alt="" />
                </div>
                <h4><span>&nbsp;</span> <span>FEMA</span></h4>
                <p>
                Stay out of flooded waters, do not drive around barricaded road or streets, turn around, don’t drown, and keep storm drains clean<br/><br/>
                Protect natural floodplain functions by keeping waterways clean and not trashing our rivers.<br/><br/>  
                    For more information you can click here<a href="https://www.fema.gov/sites/default/files/documents/fema_protect-your-home-from-flooding-brochure_2020.pdf">Protect your home from flooding.</a>  
                </p>
                
            </div>
            <div className="contact">
                  <a href="tel:(843)915-5150"
                    ><img src={`images/phone-icon.svg`} alt="save-icon" /><span
                      >(800)&thinsp;621-3362</span
                    ></a
                  >
                
                  <a href="https://www.fema.gov/emergency-managers/risk-management"
                    ><img src={`images/website-icon.svg`} alt="save-icon" /><span
                      >FEMA</span
                    ></a
                  >
                </div>
          </div>
          <div className="info-cards card-style-1">
            <div className="wrapper--inner">
                <div className="wrapper--step">
                    <div className="step"><span className="step--count">5</span></div>
                    <span className="step--Title">Ask Questions</span>
                </div>
                <div className="icon-identifier">
                  <img src={`images/flooding-icon.svg`} alt="" />
                </div>
                <h4><span>Horry County</span> <span>Floodplain Manager</span></h4>
                <p>
                  This map is a good start to learning more about flood risks in Horry
                  County. Before you purchase a property, feel free to reach out to our
                  floodplain manager to learn more about the potential impacts for your
                  property or ask questions about recent flood events.
                </p>
            </div>
            <div className="contact">
              <a href="tel:(843)915-5090"
                ><img src={`images/phone-icon.svg`} alt="save-icon" /><span
                  >(843)&thinsp;915-5090</span
                ></a
              >
              
              <a href="https://www.horrycounty.org/departments/codeenforcement"
                ><img src={`images/website-icon.svg`} alt="save-icon" /><span
                  >Horry County Code Enforcement</span
                ></a
              >
            </div>
          </div>
          <div className="info-cards card-style-1">
            <div className="wrapper--inner">
                <div className="wrapper--step">
                    <div className="step"><span className="step--count">6</span></div>
                    <span className="step--Title">Learn More</span>
                </div>
                <div className="icon-identifier">
                  <img src={`images/storm-water-icon.svg`} alt="" />
                </div>
                <h4><span>Horry County</span> <span>Stormwater</span></h4>
                <p>
                  Be in touch with the Horry County Stormwater department to learn about
                  how drainage areas and stormwater easements impact your property. It
                  is critical to keep drainage easements clear of any structures, like
                  fences and sheds.
                </p>
            </div>
            <div className="contact">
              <a href="tel:(843)915-5160"
                ><img src={`images/phone-icon.svg`} alt="save-icon" /><span
                  >(843)&thinsp;915-5160</span
                ></a
              >
            
              <a href="https://www.horrycounty.org/Departments/Stormwater"
                ><img src={`images/website-icon.svg`} alt="save-icon" /><span
                  >Horry County Stormwater</span
                ></a
              >
            </div>
          </div>
        </div>
      </div>
    </section>

    <footer className="option2">
          <div className="identifier column">
              <img src={`${BASE_URL}images/HCGovernment-footer-logo.svg`} alt="Horry County Official Logo" />

              <section className="column" >
                  <div className="row">
                      <a href="https://www.horrycounty.org"> www.horrycounty.org</a>&emsp;|&emsp;HC<strong>Government</strong>
                  </div>
                  <div className="row">
                      A product of Horry County Government
                  </div>
                  <div className="row">
                      ©2020 by Horry County Government&#8202;&mdash;&#8202;All Rights Reserved. 
                  </div>
              </section>
          </div>
          <div className="message">
              <p>This version of the website and associated maps is currently in beta-testing. This tool is still actively being developed, improved and updated. We appreciate your feedback! If you have bugs, issues, or other suggestions, please email us at <a href="mailto:mapyourmove@horrycounty.org">mapyourmove@horrycounty.org</a></p>
          </div>

      </footer>
    </>
  )
}

export default HazardsPage